import Portfolio from "./assets/portfolio.png";
import GitInsight from "./assets/GitInsight.png";
import ChatApp from "./assets/chatapp.png";

const data = [
  {
    id: 1,
    image: `${Portfolio}`,
    title: "Personal Portfolio Website",
    text: "A meticulously designed and curated showcase of my work, skills, and personality!",
    skills: ` The frontend is built using React.
        A contact facility is provided using Express.js and MongoDB.\n(MERN stack)`,
    link: "https://connectify-fpmb.onrender.com",
    // border:
  },
  {
    id: 2,
    image: `${ChatApp}`,
    title: "Mern Chat App",
    text: "A weather application that provides users with real-time weather updates for their current location and allows them to search for weather status in any area, offering convenient access to accurate weather information whenever needed.",
    skills:
      " A mern chat app which provides the facilty of doing real time chat . we can do one to one chat as well we can do group chat",
    link: "https://connectify-fpmb.onrender.com",
  },
  {
    id: 3,
    image: `${GitInsight}`,
    title: "GitInsight",
    skills:
      "A Content Driven Application for showing the details of github profile . Built using HTML and Css and Githubapi.",
    link: "https://tanmay2809.github.io/gitInsight",
  },
];
export default data;
